import type { SimpleChanges } from '@angular/core';
import { Component, ChangeDetectorRef, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { FileDropAreaType, FilesDropAreaComponent } from '@recruitee/attachments-legacy';

import { RequisitionsGeneralFacade } from '../../../facades/single-requisition/requisitions-general.facade';

@Component({
  selector: 'rt-requisitions-drop-area-container',
  template: `
    @if (dropAreaVisible && canDropFiles) {
      <rt-files-drop-area
        [targetId]="requisitionId()"
        [type]="FileDropAreaType.Requisition"
        (areaLeave)="onAreaLeave()"
        (filesDrop)="onFilesDrop()"
      />
    }
  `,
  imports: [FilesDropAreaComponent],
})
export class RequisitionsDropAreaContainerComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly requisitionsFacade = inject(RequisitionsGeneralFacade);

  public readonly requisitionId = input<number>(undefined!);
  public readonly dragEventData = input<DragEvent | null>(undefined!);

  public dropAreaVisible: boolean;
  public FileDropAreaType: typeof FileDropAreaType = FileDropAreaType;
  public canDropFiles: boolean;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.dragEventData?.currentValue) {
      this.onDragChange(changes.dragEventData.currentValue);
    }
  }
  public ngOnInit(): void {
    this.canDropFiles = this.requisitionsFacade.canManageFiles;
  }

  public onAreaLeave(): void {
    this.dropAreaVisible = false;
    this.cdRef.detectChanges();
  }

  public onFilesDrop(): void {
    this.dropAreaVisible = false;
    this.cdRef.detectChanges();

    this.router.navigate(['files'], { replaceUrl: true, relativeTo: this.route });
  }

  public onDragChange($event: DragEvent | null): void {
    if ($event) {
      const { dataTransfer } = $event;

      if (dataTransfer && dataTransfer.items.length) {
        const files = Array.from(dataTransfer.items).filter(item => item.kind === 'file');

        if (files.length === 0) {
          return;
        }
      }

      $event.preventDefault();
      $event.stopPropagation();

      this.dropAreaVisible = true;
    } else {
      this.dropAreaVisible = false;
    }
    this.cdRef.detectChanges();
  }
}
